var exports = {
  "kL": "x127c5a35--03eed2--container",
  "UU": "x127c5a35--03eed2--name",
  "mo": "x127c5a35--03eed2--name--booked",
  "o_": "x127c5a35--03eed2--building-info--booked",
  "on": "x127c5a35--03eed2--building-info",
};

module.exports = exports;
